module.exports = __webpack_public_path__ + "img/Table-geninfo.c3930b4a.svg";